module.exports = __webpack_public_path__ + "img/1c722ebb36214ac9afef106f875b0b56.036ad399.png";